function addFirstPlan(button, planId, id, quantity, key) {
  let $button = $(button);
  let $textSpan = $button.find(".button-text"); // Target only the text span

  $textSpan.text("Chargement de la réduction...");
  $button.attr("disabled", true);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: $.param({ id: key, selling_plan: planId, quantity: quantity }),
    dataType: "json",
    success: function () {
      cartRefresh(); // Reload the cart after adding subscription
    },
    error: function (error) {
   
      $textSpan.text("Économise XX% avec l'abonnement!");
      $button.attr("disabled", false);
    }
  });
}


function changePlan(value, id, quantity, key) {
  $('input[name="selling_plan"]').val(value); // Update hidden input value
  const loadingSelector = `#custom--selling-loading-${id}`;
  const sellingSelector = `.custom--selling[data-id="${id}"]`; // Ensure it selects the right element

  $(loadingSelector).show(); // Show loading indicator
  $(sellingSelector).attr('disabled', true); // Disable the selling plan dropdown

  // Function to change the cart
  const changeCart = (data) => {
    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: $.param(data),
      dataType: 'json'
    });
  };

  // Call changeCart to update the cart
  changeCart({ id: key, selling_plan: value, quantity: quantity })
    .done(() => {
        cartRefresh();
    })
    .fail((error) => {
    
    })
    .always(() => {
    
      $(sellingSelector).attr('disabled', false); // Re-enable the dropdown
    });
}

function initializeMiniCartSlider() {
    const sliders = document.querySelectorAll('.mini-cart__recommendations .swiper-container');
    sliders.forEach(slider => {
        if (!slider.classList.contains('swiper-initialized')) {
            new Swiper(slider, {
                slidesPerView: 1.2,
                spaceBetween: 20,
                freeMode: true,
            });
            slider.classList.add('swiper-initialized');
        }
    });
}


function updateCustomerView() {
    const productView = document.querySelector(".productView-ViewingProduct");
    if (!productView) return;

    productView.style.display = "block";

    const textTemplate = productView.getAttribute("data-text");
    const viewTime = parseInt(productView.getAttribute("data-customer-view-time"), 10) * 1000;
    if (!textTemplate || isNaN(viewTime)) return;

    let textElement = productView.querySelector(".text-append-custom-view-product");
    if (!textElement) {
        textElement = document.createElement("span");
        textElement.classList.add("text-append-custom-view-product");
        productView.appendChild(textElement);
    }

    const dataElement = document.querySelector(".custom-viewed-data-get");
    if (!dataElement) return;

    let storedViewers = dataElement.getAttribute("data-stored-viewers");
    
    if (!storedViewers) {
        // If no stored value, generate a new random number
        let customerViewData = dataElement.getAttribute("data-customer-view");
        if (!customerViewData) return;

        let customerViewArray = customerViewData.split(",").map(num => parseInt(num.trim(), 10));
        if (!customerViewArray.length) return;

        storedViewers = customerViewArray[Math.floor(Math.random() * customerViewArray.length)];

        // Store the chosen number in the attribute
        dataElement.setAttribute("data-stored-viewers", storedViewers);
    }

    function updateText() {
        textElement.textContent = textTemplate.replace("[number]", storedViewers);
    }

    updateText(); // Set the initial text
    setInterval(updateText, viewTime); // Keep the display logic running
}

updateCustomerView();


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(updateCustomerView, 2000); // Delay of 2 seconds
});



function updateAllSelectedOptionValues() {
  document.querySelectorAll('.combo-box').forEach((comboBox) => {
    const selectedOption = comboBox.querySelector('.combo-box__option-item[aria-selected="true"]');

    if (selectedOption) {
      const selectedValue = selectedOption.textContent.trim(); // Get text content safely

      if (selectedValue) {
        const optionSelector = comboBox.closest('.product-form__option-selector');
        const optionValueElement = optionSelector?.querySelector('.product-form__option-value');

        if (optionValueElement) {
          optionValueElement.textContent = selectedValue;
        }
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
    let preorderDiv = document.querySelector(".check-normal-product-preorder-status");
    if (preorderDiv && preorderDiv.innerHTML.trim() !== "") {
            preorderdatanormal = preorderDiv.innerHTML;
          $(".product-form__inventory-wrapper .text_container").html(`<span class="colorfont-black-2 custom-preorder-message">${preorderdatanormal}</span>`);     
    }
});



document.addEventListener("variant:changed", function (event) {
    updateAllSelectedOptionValues();
  const variant = event.detail.variant;
let variantpreorder = $(".custom-preorder-variant-" + variant.id);

let variantcrosssells = $(".cross-sells-" + variant.id);

if (variantcrosssells.length > 0) {
    $(".custom-crosse-ls-variant-wise").removeClass("active"); // Ensure other elements are deactivated
   $("cross-sells").addClass("active"); // Use jQuery method directly
    variantcrosssells.addClass("active"); // Use jQuery method directly
}

  
   $(".check-preorder-status-custom").removeClass("preorder-available-currently");
if (variantpreorder.length > 0) {




     let preorderdata = variantpreorder.attr("data");
     let preorderpopup = variantpreorder.attr("data-popup");
    if (preorderdata) {

$(".product-form__inventory-wrapper .text_container").html(`<span class="colorfont-black-2 custom-preorder-message">${preorderdata}</span>`);

    }


    if (preorderpopup) {
   
      var preorderbuttonText = $("#AddToCart").attr("preorder-text");
if (preorderbuttonText) {
  $("#AddToCart .loader-button__text").text(preorderbuttonText);
}
      
 $(".check-preorder-status-custom").addClass("preorder-available-currently");
$(".product-form__inventory-wrapper .text_container").html(`<span class="colorfont-black-2 custom-preorder-message">${preorderdata}</span>`);

    }
 
  
  
}
 


  // Remove 'active' class from all elements
  document.querySelectorAll(".metafield-data-spec-main").forEach(el => el.classList.remove("active"));
  
  // Select and activate all elements that match the variant ID
  document.querySelectorAll(".spec-data-" + variant.id).forEach(el => el.classList.add("active"));

  // Remove 'active' class from all elements
  document.querySelectorAll(".all-setss-cotent-outer").forEach(el => el.classList.remove("active"));
  
  // Select and activate all elements that match the variant ID
const elements = document.querySelectorAll(".inhalt-content-" + variant.id);


if (elements.length > 0) {
 
  $(".custom-tab-inhalt").addClass("active-inhalt");
   document.querySelector('.inhalt-content-' + variant.id).classList.add('active');
} else {

    $(".custom-tab-inhalt").removeClass("active-inhalt");
}
const elementsBadge = document.querySelectorAll(".badge-variant-data-" + variant.id);
const elementbadgehide = document.querySelectorAll('.variant-levle-badge-pdp');

if (elementbadgehide.length > 0) {
    elementbadgehide.forEach(el => {
        el.classList.remove('active');
    });
}

if (elementsBadge.length > 0) {
    elementsBadge.forEach(el => {
        el.classList.add('active');
    });
}





});


function calculateFromDiv() {
    const discountElement = document.querySelector(".discount-precentage");
    const priceWrap = document.querySelector(".custom-price-wrap");

    if (discountElement && priceWrap) {
        let qty = parseFloat(discountElement.getAttribute("qty")) || 1;
        let discount = parseFloat(discountElement.getAttribute("discount")) || 0;
        let mainPrice = parseFloat(discountElement.getAttribute("main-price")) || 0;
        let comparePriceAttr = discountElement.getAttribute("compare-price");

        // If compare-price is empty, set it to main-price
        let comparePrice = comparePriceAttr ? parseFloat(comparePriceAttr) : mainPrice;

        // Calculate final price after discount
        let finalPrice = (mainPrice - (mainPrice * discount) / 100) * qty;

        // Compare price remains as is (no discount applied)
        let finalComparePrice = comparePrice * qty;

        // Calculate savings
        let savings = finalComparePrice - finalPrice;

        // Clear previous content
        priceWrap.innerHTML = '';

        // Append Compare Price (if applicable)
        if (finalComparePrice > finalPrice) {
            priceWrap.innerHTML += `<span class="compare-price" style="text-decoration: line-through; color: #888;">$${finalComparePrice.toFixed(2)}</span> `;
        }

        // Append Final Price
        priceWrap.innerHTML += `<span class="final-price" style="font-weight: bold; color: #000;">$${finalPrice.toFixed(2)}</span> `;

        // Append Savings (if applicable)
        if (savings > 0) {
            priceWrap.innerHTML += `<span class="savings" style="color: #d00;">Du sparst $${savings.toFixed(2)}</span>`;
        }
    }
}


// Call the function
calculateFromDiv();


function calculateTotalSaving() {
    document.querySelectorAll('.discount-precentage').forEach(element => {
        let qty = parseInt(element.getAttribute('qty'), 10) || 0;
        let discount = parseFloat(element.getAttribute('discount')) || 0;
        let mainPrice = parseFloat(element.getAttribute('main-price')) || 0;
        let currency = element.getAttribute('currency') || ''; // Get currency symbol

        let totalDiscount = 0; // Default to 0
        if (qty > 0 && mainPrice > 0) {
            let totalPrice = mainPrice * qty;
            totalDiscount = (totalPrice * discount) / 100;
        }

        let formattedDiscount = totalDiscount.toFixed(2) + ' ' + currency; // Format with currency

        let savingsContainer = document.querySelector('.append-price-qty');
        if (savingsContainer) {
            savingsContainer.textContent = `${formattedDiscount}`; // Always replace content
        }
    });
}


calculateTotalSaving();





document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant; // Access variant details
 
    if (variant) {
        let price = variant.price / 100;
        let comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : '';

        let discountElement = document.querySelector('.discount-precentage');
        if (discountElement) {
            discountElement.setAttribute('main-price', price);
            discountElement.setAttribute('compare-price', comparePrice);
        }
      calculateFromDiv();
    }
});








    document.addEventListener('DOMContentLoaded', () => {
  // Select all custom video players on the page
  const videoPlayers = document.querySelectorAll('.custom-video-player');

  videoPlayers.forEach(player => {
    // Get the video and play button elements inside each video player
    const video = player.querySelector('video');
    const playButton = player.querySelector('.custom-play-button');

    // Add click event listener to the play button
    playButton.addEventListener('click', () => {
      // Play the video
      video.play();

      // Hide the play button
      playButton.style.display = 'none';

      // Add controls to the video dynamically
      video.setAttribute('controls', true);
    });

    // Optional: Add an event listener to pause the video when it ends
    video.addEventListener('ended', () => {
      // Show the play button when the video ends
      playButton.style.display = 'block';

      // Remove controls after video ends (optional)
      video.removeAttribute('controls');
    });
  });
});




    $('.footer__item-title').on('click', function () {
      // Toggle active class on the clicked element
     
      $(this).toggleClass('active'); // Toggle active on the clicked one

      // Toggle slide for the closest content
      $(this).closest('.footer__item').find('.footer__item-content').slideToggle();
    });



$(document).ready(function () {
    function checkForElement() {
        const $element = $(".rc-template__radio");
        if ($element.length) {
            var subscriptionPrice = $(".subscription-radio .rc-radio__price").html();
            var $discountElement = $(".rc-radio__subscription");
            var discountText = $discountElement.text().trim();
            var discountMatch = discountText.match(/(\d+)%/);
            var discount = discountMatch ? discountMatch[1] : null;

$("body").addClass("subscription-product-active");
           let purchaseOption = $("input[name='purchaseOption']:checked").val();

    if (purchaseOption === "subscription") {
        $("body").addClass("subscription-input-checked");
    } else {
        $("body").removeClass("subscription-input-checked");
    }
          
          


          
            if (discount) {
                // Remove the percentage from the original element
                $discountElement.text($discountElement.text().replace(/(\d+)%/, "").trim());

                // Create a new span with the extracted discount
                var $newBadge = $("<span>", {
                    class: "discount-recharge-badge",
                    text: "spare "+discount + "%" // Set the extracted percentage
                });

                // Append the new badge after the original discount element
                $discountElement.after($newBadge);
            }

            $(".rc-widget").show();
            return true;
        }
        return false;
    }

    function pollForElement(maxAttempts, interval) {
        let attempts = 0;
        
        const intervalId = setInterval(() => {
            attempts++;
            if (checkForElement() || attempts >= maxAttempts) {
                clearInterval(intervalId);
            }
        }, interval);
    }

    // Start polling (check every 100ms, up to 3 seconds)
    pollForElement(30, 100);
});

$(document).on("change", "input[name='purchaseOption']", function () {
    let purchaseOption = $("input[name='purchaseOption']:checked").val();

    if (purchaseOption === "subscription") {
        $("body").addClass("subscription-input-checked");
    } else {
        $("body").removeClass("subscription-input-checked");
    }
});

(function() {
    if (window.location.search.includes("cart-drawer-open")) {
        let miniCart = document.getElementById("mini-cart");
        
        if (miniCart) {
            miniCart.open = true; // Open immediately if found
        } else {
            // If not found yet, retry when DOM is ready
            document.addEventListener("DOMContentLoaded", function() {
                let miniCartLoaded = document.getElementById("mini-cart");
                if (miniCartLoaded) {
                    miniCartLoaded.open = true;
                }
            });
        }
    }
})();


/* Dynamic shipping info below price on PDP for products over 4000 cents */

(function () {
  function updateTaxText() {
    const taxNote = document.querySelector(".product-meta__taxes-included");
    if (!taxNote) return;

    let price = null;

    // Prüfen, welche Preisdarstellung gerade sichtbar ist
    const normalPriceEl = document.querySelector(".custom-price-without-subs:not([style*='display: none']) .price--large");
    const subPriceEl = document.querySelector(".custom-price-with-subs:not([style*='display: none']) .price--large");

    if (normalPriceEl) {
      price = parseFloat(normalPriceEl.textContent.replace(/[^\d,.-]/g, "").replace(",", "."));
    } else if (subPriceEl) {
      price = parseFloat(subPriceEl.textContent.replace(/[^\d,.-]/g, "").replace(",", "."));
    }

 if (price === null) return;

if (price >= 40) {
  // "Livraison gratuite" highlighted
  taxNote.innerHTML = 'Taxes incluses avec <strong style="color:#007681">livraison gratuite</strong>';
} else {
  taxNote.textContent = "Taxes incluses, frais de livraison en sus";
}
  }

  // Initial ausführen
  updateTaxText();

  // MutationObserver auf Preiscontainer, reagiert auf Preisänderungen
  const priceContainers = document.querySelectorAll(".product-meta__price-list-container");
  priceContainers.forEach(container => {
    const observer = new MutationObserver(updateTaxText);
    observer.observe(container, { childList: true, subtree: true });
  });


})();


document.addEventListener("click", function (e) {
  const button = e.target.closest(".shopify-section--custom-newsletter button");
  if (button) {
    try {
      Shopify.analytics.publish("datalayer_event", {
        event: "newsletter_subscribe"
      });
    } catch (err) {
      console.warn("Analytics publish failed:", err);
    }
  }
}, true);



